<template>
  <div>
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增活动</el-button>
    </div>
    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column label="封面" width="90">
        <template slot-scope="{ row }">
          <img v-if="row.coverUrl" :src="row.coverUrl" class="thumb" />
          <span v-else class="muted">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="160" />
      <el-table-column prop="sortNo" label="排序" width="80" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.status === 'ON' ? 'success' : 'info'">{{ row.status === 'ON' ? '上架' : '下架' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="browseCount" label="浏览" width="80" />
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#f56c6c" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="form.id ? '编辑活动' : '新增活动'"
      :visible.sync="visible"
      width="880px"
      top="5vh"
      append-to-body
    >
      <el-form :model="form" label-width="90px">
        <el-form-item label="标题" required>
          <el-input v-model="form.title" maxlength="64" />
        </el-form-item>
        <el-form-item label="封面">
          <el-upload
            action="#"
            :http-request="elUploadHttpRequest"
            :show-file-list="false"
            :on-success="onCoverOk"
            accept="image/*"
          >
            <el-button size="small" type="primary" plain>上传封面</el-button>
          </el-upload>
          <div v-if="form.coverUrl" class="cover-preview">
            <img :src="form.coverUrl" />
          </div>
          <el-input v-model="form.coverUrl" placeholder="或粘贴图片地址" style="margin-top:8px" />
        </el-form-item>
        <el-form-item label="内容">
          <rich-editor v-if="visible" v-model="form.content" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortNo" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="ON">上架</el-radio>
            <el-radio label="OFF">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listBanners, saveBanner, deleteBanner } from '../../api/cms'
import RichEditor from '../../components/RichEditor.vue'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'CmsBanner',
  components: { RichEditor },
  data() {
    return {
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    async load() {
      this.loading = true
      try {
        const res = await listBanners()
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      this.form = row
        ? { ...row }
        : { title: '', coverUrl: '', content: '', sortNo: 0, status: 'ON' }
      this.visible = true
    },
    onCoverOk(res) {
      const data = (res && res.data) || res || {}
      if (data.url) this.$set(this.form, 'coverUrl', data.url)
    },
    async save() {
      if (!this.form.title) return this.$message.warning('请填写标题')
      this.saving = true
      try {
        await saveBanner(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    remove(row) {
      this.$confirm('确定删除该活动？', '提示', { type: 'warning' })
        .then(async () => {
          await deleteBanner(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.thumb { width: 56px; height: 40px; object-fit: cover; border-radius: 4px; }
.cover-preview { margin-top: 8px; }
.cover-preview img { max-width: 240px; max-height: 120px; border-radius: 6px; }
.muted { color: #94a3b8; }
</style>
